import { useState } from "react";
import axios from "axios";
import styles from "./styles.module.css";
import GoogleLoginButton from "../GoogleLoginButton";


const Login = ({ onSwitchToSignup }) => {
  const [data, setData] = useState({ email: "", password: "" });
  const [error, setError] = useState("");

  const handleChange = ({ currentTarget: input }) => {
    const { name, value } = input;
    let sanitizedValue = value;
    if (name === "email") sanitizedValue = value.trim().toLowerCase();
    if (name === "password") sanitizedValue = value.slice(0, 64);
    setData({ ...data, [name]: sanitizedValue });
    setError(""); // czyść error po każdej zmianie
  };

  const validateLogin = () => {
    const { email, password } = data;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) return "Nieprawidłowy adres e-mail.";
    if (!password || password.length < 6) return "Hasło musi mieć co najmniej 6 znaków.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationError = validateLogin();
    if (validationError) {
      setError(validationError);
      return;
    }
    try {
      const url = `${process.env.REACT_APP_DEV_SERVER}/auth`;
      const { data: res } = await axios.post(url, data);
      localStorage.setItem("token", res.data);
      localStorage.setItem("email", data.email);
      window.location.href = "/";
    } catch (error) {
      if (
        error.response &&
        error.response.status >= 400 &&
        error.response.status <= 500
      ) {
        setError(error.response.data.message || "Nieprawidłowy email lub hasło.");
      }
    }
  };

  return (
    <>
      <div className={styles.glass_logo_circle}>
        <img src="/logo192.png" alt="logo" />
      </div>
      <h2 className={styles.glass_modal_title}>Zaloguj się do konta</h2>
      <form className={styles.glass_form} onSubmit={handleSubmit}>
        <div className={styles.glass_input_wrap}>
          <span className={styles.glass_input_icon}>
            <svg width="22" height="22"><circle cx="11" cy="10" r="6"/><ellipse cx="11" cy="18" rx="7" ry="3"/></svg>
          </span>
          <input
            type="email"
            placeholder="Email"
            name="email"
            onChange={handleChange}
            value={data.email}
            required
            className={styles.glass_input}
            autoComplete="username"
          />
        </div>
        <div className={styles.glass_input_wrap}>
          <span className={styles.glass_input_icon}>
            <svg width="22" height="22"><rect x="6" y="11" width="10" height="7" rx="3.5"/><circle cx="11" cy="14.5" r="1.4"/></svg>
          </span>
          <input
            type="password"
            placeholder="Hasło"
            name="password"
            onChange={handleChange}
            value={data.password}
            required
            className={styles.glass_input}
            autoComplete="current-password"
          />
        </div>
        {error && <div className={styles.glass_error}>{error}</div>}
        <button type="submit" className={styles.glass_login_btn}>Zaloguj</button>
      </form>
      <div className={styles.glass_bottom_row}>
  <div className={styles.glass_bottom_row_text}>
    <span>Nie masz konta?</span>
    <button
      type="button"
      className={styles.glass_link_btn}
      onClick={onSwitchToSignup}
    >
      Zarejestruj się
    </button>
  </div>
    <GoogleLoginButton onClick={() => window.location.href = `${process.env.REACT_APP_DEV_SERVER}/auth/google`} />
  </div>
    </>
  );
};
export default Login;
